var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "Área da unidade de produção animal (ha):",
                  content: _vm.pratica.area
                }
              }),
              _vm._v(" "),
              _c("app-display", {
                attrs: {
                  label: "Número de animais por área (unidade/ha):",
                  content: _vm.pratica.numeroAnimais
                }
              }),
              _vm._v(" "),
              _c("app-display", {
                attrs: {
                  label: "Espécie e raça:",
                  content: _vm.formataEspecieRaca(_vm.pratica.especiesRacas),
                  isContentInNextLine: true
                }
              }),
              _vm._v(" "),
              _c("app-display", {
                attrs: {
                  label: "Data de início da implementação (mês/ano):",
                  content: _vm.formataStringYearMonthToBr(
                    _vm.pratica.dataInicio
                  )
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "Tipo de sistema:",
                  content: _vm.formataTipoSistema(_vm.pratica.tiposSistemas)
                }
              }),
              _vm._v(" "),
              _c("app-display", {
                attrs: {
                  label: "Outro tipo de sistema:",
                  content: _vm.pratica.outrosTipoSistema
                }
              }),
              _vm._v(" "),
              _c("app-display", {
                attrs: {
                  label: "Tipo de alimentação:",
                  content: _vm.formataTiposAlimentacoes(
                    _vm.pratica.tiposAlimentacao
                  )
                }
              }),
              _vm._v(" "),
              _c("app-display", {
                attrs: {
                  label: "Outro tipo de alimentação:",
                  content: _vm.pratica.outroTipoAlimentacao
                }
              }),
              _vm._v(" "),
              _c("app-display", {
                attrs: {
                  label: "Suplementação mineral?",
                  content: _vm.pratica.hasSuplementacaoMineral ? "Sim" : "Não"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("Irrigacao", {
        attrs: {
          irrigacao: Object.assign(
            {},
            { possuiIrrigacao: _vm.pratica.possuiIrrigacao },
            _vm.pratica.irrigacao
          )
        }
      }),
      _vm._v(" "),
      _c("Financiamento", {
        attrs: {
          financiamento: {
            financiamentos: _vm.pratica.financiamentos,
            outroFinanciamento: _vm.pratica.outroFinanciamento
          }
        }
      }),
      _vm._v(" "),
      _c("Descricao", { attrs: { descricao: _vm.pratica.descricao } })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticClass: "title-praticas" }, [
        _vm._v("Dados da prática")
      ]),
      _vm._v(" "),
      _c("hr")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-566d6dbd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-566d6dbd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Praticas/TI/TI.vue
// module id = null
// module chunks = 